import { provideAnimationsAsync } from '@angular/platform-browser/animations/async';
import { ApplicationConfig, inject } from '@angular/core';
import {
  HttpHandlerFn,
  HttpRequest,
  provideHttpClient,
  withInterceptors,
} from '@angular/common/http';
import {
  provideRouter,
  withComponentInputBinding,
  withRouterConfig,
} from '@angular/router';

import { NO_AUTH, NO_CACHE } from './models';
import { ROUTES } from './app.routes';
import { HttpService } from './services/http.service';

export const appConfig: ApplicationConfig = {
  providers: [
    provideAnimationsAsync(),
    provideHttpClient(withInterceptors([jwtInterceptor, sensitiveInterceptor])),
    provideRouter(
      ROUTES,
      withComponentInputBinding(),
      withRouterConfig({ paramsInheritanceStrategy: 'always' }),
    ),
    // {
    //   provide: CSP_NONCE,
    //   useValue: '123456789' // TODO Randomize
    // }
  ],
};

function jwtInterceptor(req: HttpRequest<unknown>, next: HttpHandlerFn) {
  if (req.context.get(NO_AUTH)) {
    return next(req);
  }
  const token = inject(HttpService).tokens.access;
  return next(
    req.clone({
      headers: req.headers.set('Authorization', `Bearer ${token}`),
    }),
  );
}

function sensitiveInterceptor(req: HttpRequest<unknown>, next: HttpHandlerFn) {
  if (!req.context.get(NO_CACHE)) {
    return next(req);
  }
  return next(
    req.clone({
      headers: req.headers.set('Cache-Control', 'no-store'),
    }),
  );
}
